import { intranetNewsPath } from '@gb-ticket/shared-types';
import { toast } from 'sonner';

import { ApiRequestError } from '@/lib/api';
import { IntranetPollView } from '@/products/intranet/components/intranet-poll';
import {
  useIntranetPoll,
  useVoteIntranetPoll,
} from '@/products/intranet/features/intranet/use-intranet-poll';

/** Poll block under the teaser in list-view feed cards only. */
export function IntranetFeedPoll({ slug, allowVote }: { slug: string; allowVote: boolean }) {
  const pollQuery = useIntranetPoll(slug);
  const vote = useVoteIntranetPoll(slug);
  const poll = pollQuery.data?.poll;

  if (pollQuery.isPending || !poll) {
    return null;
  }

  return (
    <div className="px-4 pb-3">
      <IntranetPollView
        poll={poll}
        voting={allowVote}
        pending={vote.isPending}
        articleHref={intranetNewsPath(slug)}
        onVote={(optionId) => {
          void vote.mutateAsync({ optionId }).catch((error: unknown) => {
            toast.error(
              error instanceof ApiRequestError ? error.message : 'Abstimmen fehlgeschlagen.',
            );
          });
        }}
      />
    </div>
  );
}
